import { GenericParamFields } from "entity/Indicador/components/ParamFields";
import TC from "..";

export function TCParamFields({ tipoIndicadorField }) {
    return <GenericParamFields name={TC.field + tipoIndicadorField} />;
}
